import _ from 'lodash';
import Vue from 'vue';

export default class FormErrors {
  constructor(errors) {
    this.errors = errors;
  }

  hasErrors() {
    return !_.isEmpty(this.errors);
  }

  has(field) {
    return _.indexOf(_.keys(this.errors), field) > -1;
  };

  all() {
    return this.errors;
  }

  flatten() {
    return _.flatten(_.toArray(this.errors));
  }

  get(field) {
    if (this.has(field)) {
      return this.errors[field][0];
    }
  }

  set(errors) {
    if (typeof errors === 'object') {
      this.errors = errors;
    } else {
      this.errors = {'form': ['Something went wrong. Please try again or contact customer support.']};
    }
  }

  forget(field) {
    if (typeof field === 'undefined') {
      this.errors = {};
    } else {
      Vue.delete(this.errors, field);
    }
  }

  state(field) {
    if (this.has(field)) {
      return false;
    }

    return null;
  }

  feedback(field) {
    return this.get(field);
  }

}
